/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import MessageService, { MessageType } from '../servicios/MessageService'
const isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?$/

export const newGuid = function() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export const RemoveObjectById = function(id: any, arr: any[]) {
  const indexOfObject = arr.findIndex((obj: { id: any }) => {
    return obj.id === id
  })

  if (indexOfObject !== -1) {
    arr.splice(indexOfObject, 1)
  }
  return arr
}

const isIsoDateString = (value: string | any): boolean => {
  return value && typeof value === 'string' && isoDateFormat.test(value)
}

const handleDates = (body: Record<string, Date> | null | undefined) => {
  if (body === null || body === undefined || typeof body !== 'object') return body

  for (const key of Object.keys(body)) {
    const value = body[key]
    if (isIsoDateString(value)) body[key] = new Date(value)
    else if (typeof value === 'object') handleDates(value as any)
  }
}

const handleDatesApollo = (body: any | null | undefined) => {
  if (body === null || body === undefined || typeof body !== 'object') return body

  for (const key of Object.keys(body)) {
    const value = body[key]
    if (isIsoDateString(value)) body[key] = new Date(value)
    else if (typeof value === 'object') handleDates(value as any)
  }
}


const isNumeric = (str: string | number | null | undefined) => {
  if (str === '' || str == null || str === undefined) return false
  if (typeof str !== 'string' || !str) return false

  try {
    // str = str.replaceAll(' ', '')

    // return !isNaN(str) && !isNaN(parseFloat(str))
  } catch {
    return false
  }
}

const groupByToMap = <T, Q>(array: T[], predicate: (value: T, index: number, array: T[]) => Q) =>
  array.reduce((map, value, index, array) => {
    const key = predicate(value, index, array)
    map.get(key)?.push(value) ?? map.set(key, [value])
    return map
  }, new Map<Q, T[]>())

const lockEdit = (canEdit: any, data: Record<string, boolean>) => {
  if (!canEdit && data) {
    for (const propt in data) {
      data[propt] = true
    }
  }
}

const addYears = (dt: { setFullYear: (arg0: any) => string | number | Date, getFullYear: () => any }, n: any) => {
  // return new Date(dt.setFullYear(dt.getFullYear() + n))
}

const copyToClipBoard = (texto: string) => {
  // navigator.clipboard.writeText(texto)
  MessageService.showToast(MessageType.Correcto, '', 'Se han copiado los registros al portapapeles.')
}



const utf8_to_b64 = ( str:string ) => {
  return btoa(unescape(encodeURIComponent( (str ?? '') )));
}

const  b64_to_utf8 = ( str:string ) => {
  return decodeURIComponent(escape(window.atob( str )));
}


const getDeepKeys = (obj:any) => {
  let keys = Array<String>();
  for(let key in obj) {
      keys.push(key);
      if(typeof obj[key] === "object") {
          let subkeys = getDeepKeys(obj[key]);
          keys = keys.concat(subkeys.map(function(subkey:any) {
              return key + "." + subkey;
          }));
      }
  }
  return keys;
}


const getDeepObjectByKey = (obj:any, keyInput:string,keyValue:string) : object | null => {

  for(let key in obj) {
      //keys.push(key);
      if (key === keyInput && obj[key] !== "object" && obj[key] === keyValue)
      {
        return obj;
        //return obj[key]
      }

      if(typeof (obj[key] ?? '')  === "object") {
          return getDeepObjectByKey(obj[key],keyInput,keyValue);
          
      }
  }
  return null;
}

const isUUID = ( uuid:string ) :boolean  => {
  let s = "" + uuid;

  const resu = s.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
  if (resu === null) {
    return false;
  }
  return true;
}

export default { isUUID,newGuid, RemoveObjectById, handleDates,handleDatesApollo, isNumeric, groupByToMap, lockEdit, addYears, copyToClipBoard,utf8_to_b64,b64_to_utf8, getDeepKeys,getDeepObjectByKey }
